exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error[data-v-27034efb]{left:0;bottom:-15px;right:-200px;text-align:left;padding-left:10px}\n", ""]);

// exports
